<template>
  <div id="signup">
    <div class="content bg-black middle login-box">
      <div class="cell">
        <div class="container">
            <div class="row">
                      <div class="col-xs-6">
                        <div class="text-center inlineb mt30p">
                          <img src="../assets/images/logo-ww.png" alt="">
                          <p class="sub-title white mt50">PARTNER NETWORK</p>
                        </div>

                      </div>
                      <div class="col-xs-6">
                         <p class="sub-title white text-center">REGISTER AN ACCOUNT</p>
                         <p class="white text-center">STEP {{active}} /3 </p>
                          <form class="form-horizontal font12 mt50">
                            <div class="step1" v-if="active==1">
                              <el-form :model="step1" ref="step1" status-icon validate-on-rule-change>
                                <div class="form-group">
                                    <label class="col-sm-4 control-label white">* Title</label>
                                    <div class="col-sm-8">
                                      <el-form-item class="white" prop="title" :rules="[{ required: true, message: 'Title is required!'}]">
                                        
                                        <el-radio-group v-model="step1.title" class="white">
                                          <el-radio label="Mr" value='Mr'></el-radio>
                                          <el-radio label="Mrs" value='Mrs'></el-radio>
                                         
                                        </el-radio-group>
                                      </el-form-item>
                                      
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-4 control-label white">* First name:</label>
                                    <div class="col-sm-8">
                                      <el-form-item class="white" prop="first_name" :rules="[{ required: true, message: 'First name is required!' }]">
                                        <el-input type="text" v-model="step1.first_name"></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                   <div class="form-group">
                                      <label class="col-sm-4 control-label white">* Last name:</label>
                                      <div class="col-sm-8">
                                         <el-form-item class="white" prop="last_name" :rules="[{ required: true, message: 'Last name is required!' }]">
                                            <el-input type="text" v-model="step1.last_name"></el-input>
                                          </el-form-item>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label class="col-sm-4 control-label white">* Country:</label>
                                      <div class="col-sm-8">
                                        <div class="el-input el-input--suffix">
                                          <el-form-item class="white" prop="country" :rules="[{ required: true, message: 'Country is required!' }]">
                                            <country-select className="el-input__inner" :country="step1.country" v-model="step1.country" />
                                            <span class="el-input__suffix">
                                              <span class="el-input__suffix-inner">
                                                <i class="el-select__caret el-input__icon el-icon-arrow-down"></i>
                                              </span>
                                            </span>
                                          </el-form-item>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label class="col-sm-4 control-label white">* City:</label>
                                      <div class="col-sm-8">
                                        <el-form-item class="white" prop="city" :rules="[{ required: true, message: 'City is required!' }]">
                                            <el-input type="text" v-model="step1.city"></el-input>
                                          </el-form-item>
                                        
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label class="col-sm-4 control-label white">* Preferred currency:</label>
                                      <div class="col-sm-8">
                                         <el-form-item class="white" prop="currency" :rules="[{ required: true, message: 'Preferred currency is required!' }]">
                                           
                                            <el-select v-model="step1.currency" class="w100">
                                              <el-option label="USD" value="USD"></el-option>
                                              <el-option label="EUR" value="EUR"></el-option>
                                              <el-option label="CNY" value="CNY"></el-option>
                                            </el-select>
                                          </el-form-item>
                                      </div>
                                    </div>

                              </el-form>
                             

                            </div>
                            <div class="step2" v-if="active==2">
                              <el-form :model="step2" ref="step2" status-icon validate-on-rule-change>
                                <div class="form-group">
                                    <label class="col-sm-12 control-label white">* Which market segments you are covering: (select one or more)</label>
                                    <div class="col-sm-12 mt10">
                                      <el-form-item class="white" prop="market" :rules="[{ required: true, message: 'Please select a option!',trigger: 'blur'}]">
                                        <el-checkbox-group v-model="step2.market" class="white">
                                          <el-checkbox label="Residential" value='Residential'></el-checkbox>
                                          <el-checkbox label="Hospitality" value='Hospitality'></el-checkbox>
                                          <el-checkbox label="Commerial/Office" value='Commerial/Office'></el-checkbox>
                                          <el-checkbox label="Cruise/Yacht" value='Cruise/Yacht'></el-checkbox>
                                          <el-checkbox label="Other" value='Other'></el-checkbox>
                                          
                                        </el-checkbox-group>
                                      </el-form-item>
                                      
                                    </div>
                                  </div>
                                  <div class="form-group mt20">
                                    <label class="col-sm-12 control-label white">* Are you a Certified Dealer?</label>
                                    <div class="col-sm-12 mt10">

                                      <el-form-item class="white" prop="is_dealer" :rules="[{ required: true, message: 'Please select a option!',trigger: 'blur'}]">
                                        <el-checkbox-group v-model="step2.is_dealer" class="white">
                                            <el-checkbox label="No" value='No' ></el-checkbox>
                                            <el-checkbox label="KNX" value='KNX' v-if="step2.is_dealer.indexOf('No')===-1"></el-checkbox>
                                            <el-checkbox label="Crestron" value='Crestron' v-if="step2.is_dealer.indexOf('No')===-1"></el-checkbox>
                                            <el-checkbox label="Control 4" value='Control 4' v-if="step2.is_dealer.indexOf('No')===-1"></el-checkbox>
                                            <el-checkbox label="Dynalite" value='Dynalite' v-if="step2.is_dealer.indexOf('No')===-1"></el-checkbox>
                                          </el-checkbox-group>
                                       </el-form-item>
                                    </div>
                                  </div>
                                  <div class="form-group mt20">
                                    <label class="col-sm-6 control-label white">* Which brands are you carrying:</label>
                                    <div class="col-sm-6 mt10">
                                      <el-form-item class="white" prop="brands" :rules="[{ required: true, message: 'The filed is required!',trigger: 'blur'}]">
                                          <el-input type="text" v-model="step2.brands"></el-input>
                                       </el-form-item>
                                      
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-6 control-label white">* How many sales representatives are in your Sales team?</label>
                                    <div class="col-sm-6 mt10">
                                       <el-form-item class="white" prop="many_sales" :rules="[{ required: true, message: 'The filed is required!',trigger: 'blur'}]">
                                          <el-input type="text" v-model="step2.many_sales"></el-input>
                                       </el-form-item>
                                     
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-6 control-label white">* How many engineers are in your Support Team?</label>
                                    <div class="col-sm-6 mt10">
                                      <el-form-item class="white" prop="many_engineers" :rules="[{ required: true, message: 'The filed is required!',trigger: 'blur'}]">
                                          <el-input type="text" v-model="step2.many_engineers"></el-input>
                                       </el-form-item>
                                      
                                    </div>
                                  </div>

                              </el-form>
                              
                               
                            </div>
                            <div class="step3" v-if="active==3">
                              <el-form :model="step3" ref="step3" status-icon :rules="rules" :validate-on-rule-change="false">
                                <input type="text" value="" id="user_name"/> <!-- bot challenge --> 
                                <div class="form-group has-feedback">
                                  <label class="col-sm-4 control-label white">* Email</label>
                                  <div class="col-sm-8">
                                    <el-form-item prop="email" 
                                    :rules="[{ message: 'Email is required!',trigger: 'blur'},{ type: 'email', message: 'Please enter the correct email format!',trigger: 'blur'}]">
                                      <el-input v-model="step3.email"></el-input>
                                    </el-form-item>
                                    
                                    
                                  </div>
                                </div>
                                <div class="form-group has-feedback">
                                  <label class="col-sm-4 control-label white">* Phone</label>
                                  <div class="col-sm-8">
                                    <el-form-item prop="phone" 
                                    :rules="[{ message: 'Phone is required!',trigger: 'blur'}]">
                                      <el-input v-model="step3.phone"></el-input>
                                    </el-form-item>
                                   
                                    
                                  </div>
                                </div>
                                <div class="form-group has-feedback">
                                    <label class="col-sm-4 control-label white">* Password</label>
                                    <div class="col-sm-8">
                                       <el-form-item prop="password">
                                          <el-input v-model="step3.password" show-password></el-input>
                                        </el-form-item>
                                    </div>
                                  </div>
                                  <div class="form-group has-feedback">
                                    <label class="col-sm-4 control-label white">* Confirm password</label>
                                    <div class="col-sm-8">
                                      <el-form-item prop="check_password">
                                          <el-input v-model="step3.check_password" show-password></el-input>
                                        </el-form-item>
                                      
                                    </div>
                                  </div>
                                  <div class="form-group has-feedback mt40">
                                    <div class="col-sm-12">
                                      <el-form-item prop="receive">
                                         <el-checkbox v-model="step3.receive" >I would like to receive Black Nova’s latest news and updates</el-checkbox>
                                      </el-form-item>
                                      
                                      
                                    </div>
                                    <div class="col-sm-12 mt20">
                                      <el-form-item prop="agree" >
                                          <el-checkbox v-model="step3.agree" >* I agree with Black Nova <b>Privacy Policy</b> and <b>Terms of Service</b></el-checkbox>
                                      </el-form-item>
                                    </div>
                                  </div>

                              </el-form>


                            </div> 
                          </form>

                      </div>
                  </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16" >
      <span class="white click inlineb w10" @click="back()" v-if="active!==1"><i class="iconfont3 icon-back"></i> BACK </span>
      <span class="orange click inlineb w10" v-if="active!==3" @click="next()">NEXT <i class="iconfont3 icon-next"></i> </span>
      <span class="orange click inlineb w10" v-if="active==3" @click="signup()">SIGN UP <i class="iconfont3 icon-next"></i> </span>
      <!-- <div class="container-fluid">
         <div class="col-xs-6 text-left"> </div>
         <div class="col-xs-6 text-right"></div>  
      </div>   -->
    </div>
  
  </div>
</template>
<style scoped>
#user_name {
  opacity: 0;
  position: absolute;
  left: -9999998px;
}
</style>
<script>
import axios from "axios";
import '../assets/css/login.css';
export default {
  name: 'login',
  data() {
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please set up password!'));
        } else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please confirm password!'));
        } else if (value !== this.step3.password) {
          callback(new Error('Two input password must be consistent!'));
        } else {
          callback();
        }
      };
      var validatePass3 = (rule, value, callback) => {
        if (value === false) {
          callback(new Error('You should agree the terms!'));
        } else {
          callback();
        }
      };
    return {
      step1:{
        title:'',
        first_name:'',
        last_name:'',
        country:'',
        city:'',
        currency:'',
      },
      step2:{
        market:[],
        is_dealer:[],
        brands:'',
        many_sales:'',
        many_engineers:'',
      },
      step3:{
        password:'',
        email:'',
        phone:'',
        check_password:'',
        agree:false,
        receive:true,
      },
      active: 1,
      rules: {
          agree: [
            { validator: validatePass3, trigger: ['blur']}
          ],
          password: [
            { validator: validatePass, trigger: ['blur', 'change'] }
          ],
          check_password: [
            { validator: validatePass2, trigger: ['blur', 'change'] }
          ]
        }
    };
    
  },
  methods:{
    login(){
      this.$router.push({path:'/login'})
    },
    signup(){
      this.$refs.step3.validate((valid) => {
          if (valid) {
             axios.post('/user/',{
                  "user":{
                    title:this.step1.title,
                    first_name:this.step1.first_name,
                    last_name:this.step1.last_name,
                    country:this.step1.country,
                    city:this.step1.city,
                    currency:this.step1.currency,
                    market:this.step2.market,
                    is_dealer:this.step2.is_dealer,
                    brands:this.step2.brands,
                    many_sales:this.step2.many_sales,
                    many_engineers:this.step2.many_engineers,
                    user_name:document.getElementById('user_name').value,
                    phone:this.step3.phone,
                    email:this.step3.email,
                    password:this.step3.password,
                    receive:this.step3.receive
                  }
              })
              .then(res => {
                  if(res.data.ok == 1){
                    this.$message({
                          type: 'success',
                          message: 'Sign Up Successful!'
                      })
                      this.$router.push({path:'/login'})
                  }else{
                      this.$message({
                          type: 'error',
                          message: 'Create Failed!'
                      })
                  }
              })
              .catch(function (error) { // 请求失败处理
                  alert(error);
              });
          } else {
            window.console.log('error submit!!');
            return false;
          }
        });
      
    },
    next(){
      if(this.active == 1) {
        this.$refs.step1.validate((valid) => {
          if (valid) {
            this.active = 2
          } else {
            window.console.log('error submit!!');
            return false;
          }
        });
        return false;
      }else if(this.active == 2){
        this.$refs.step2.validate((valid) => {
          if (valid) {
            this.active = 3;
            if(!this.step2.is_dealer.indexOf('No')===-1){
               this.step2.is_dealer = ['No']
            }
          } else {
            window.console.log('error submit!!');
            return false;
          }
        });
        
      }
        
      
    },
    back(){
      if (this.active-- <= 1) this.active = 1;

    },
  },
    
  created:function () {
        this.$parent.headerBg();
        this.$parent.footerB();
        // this.$parent.footerCenter();
     
  }
}


</script>

<style>
</style>
